import React, { Component } from 'react';
import ResponsiveContentLayout from "../../components/ResponsiveContentLayout";
import { connect } from "react-redux";
import NoSidebarLayout from "../../layouts/layout-components/no-sidebar-layout";
import "../sprite-ui/sprite-ui.scss";
import "./verify-payment.scss";
import { externalPaymentService } from "../../_services/externalPayment.service";
import { appConstants } from "../../_constants";
import { alertActions } from "../../_actions";
import BackButton from '../../components/BackButton';
import { appHelpers } from "../../_helpers/app.helpers";
import axios from "axios";

let source;

class VerifyPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlObject: null,
      responseData: {},
      status: "",
      failureResponse: "",
      isVerifying: true,
    };

    source = axios.CancelToken.source();
  }

  componentWillMount() {
    let url = window.location.href;
    if (url.substring(0, url.indexOf("?")) === "") {
      return;
    } else {
      let baseUrlLength = url.substring(0, url.indexOf("?")).length + 1;
      let remainingURL = '&' + url.substring(baseUrlLength);
      let splitRestUrl = remainingURL.split("&");
      let urlArrayWithoutBase = splitRestUrl.slice(1);

      // ✅ Parse Paystack callback parameters
      const urlObject = {
        inv: null,
        rrr: null,
        gwId: null,
        reference: null, // Paystack adds this
        status: null,    // Paystack may add this
      };

      urlArrayWithoutBase.forEach(item => {
        let itemLength = item.substring(0, item.indexOf("=")).length;
        let urlObjProperty = item.substring(0, item.indexOf("="));
        let urlObjValue = item.substring(itemLength + 1);
        urlObject[urlObjProperty] = decodeURIComponent(urlObjValue);
      });

      this.setState({ urlObject });
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { urlObject } = this.state;

    if (urlObject && urlObject.inv) {
      dispatch(alertActions.startRequest());
      
      // ✅ Prepare payload for verification
      const payload = {
        inv: urlObject.inv,
        rrr: urlObject.rrr,
        gwId: urlObject.gwId,
        // reference: urlObject.reference || urlObject.trxref,
      };


      // ✅ Call backend to verify payment status
      externalPaymentService.verifyPayment(payload, source.token)
        .then(res => {
          dispatch(alertActions.stopRequest());
          const response = res.response;


          if (res.status === appConstants.SUCCESS_RESPONSE) {
            // ✅ Check if payment was successful
            if (response.isSuccessful && response.status === "success") {
              this.setState({ 
                responseData: response, 
                status: "success",
                isVerifying: false 
              });
            } else {
              // ✅ Payment verification returned but payment failed
              this.setState({ 
                responseData: response,
                failureResponse: "Payment was not successful", 
                status: "failure",
                isVerifying: false 
              });
            }
          } else if (res.status === appConstants.ERROR_RESPONSE) {
            this.setState({ 
              responseData: response,
              failureResponse: response.message || "Payment verification failed", 
              status: "failure",
              isVerifying: false 
            });
          }
        })
        .catch(error => {
          console.error("Payment verification error:", error);
          dispatch(alertActions.stopRequest());
          this.setState({ 
            failureResponse: "Unable to verify payment. Please contact support.",
            status: "failure",
            isVerifying: false 
          });
        });
    } else {
      // ✅ No invoice number in URL
      this.setState({ 
        failureResponse: "Invalid payment verification link",
        status: "failure",
        isVerifying: false 
      });
    }
  }

  clearPaymentData = () => {
    localStorage.removeItem("Invoice Number");
    localStorage.removeItem("Invoice Details");
    localStorage.removeItem("Paystack_ResponseUrl");
    localStorage.removeItem("Paystack_InvoiceNumber");
  }

  navigateBack = () => {
    const { history } = this.props;

    // ✅ Clear all payment-related localStorage items
    this.clearPaymentData();

    // ✅ Navigate back to payment page
    history.push("/invoice-payment");
  }

  formatCurrency = (amount = 0) => {
    const formatter = new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
      minimumFractionDigits: 2,
    });
    return formatter.format(amount);
  }

  componentWillUnmount() {
    if (source) {
      source.cancel();
    }
  }

  render() {
    const { urlObject, status, responseData, failureResponse, isVerifying } = this.state;
    
    return (
      <div>
        <NoSidebarLayout>
          <ResponsiveContentLayout
            pageTitle={"Verify Payment"}
            height={'70vh'}
            requesting={this.props.requesting}
            actions={
              <BackButton navigateBack={this.navigateBack} />
            }
          >
            <div className="confirm-payment">
              <div className="confirm-payment__details">
                {isVerifying && (
                  <div style={{ textAlign: 'center', padding: '40px' }}>
                    <div style={{ 
                      width: 60, 
                      height: 60, 
                      border: '4px solid #f3f3f3',
                      borderTop: '4px solid #1F1F1F',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      margin: '0 auto 20px'
                    }} />
                    <h3>Verifying your payment...</h3>
                    <p>Please wait while we confirm your transaction.</p>
                    <style>
                      {`
                        @keyframes spin {
                          0% { transform: rotate(0deg); }
                          100% { transform: rotate(360deg); }
                        }
                      `}
                    </style>
                  </div>
                )}

                {status === "success" && !isVerifying && (
                  <div className={"confirm-payment__details-success"}>
                    <h3>🎉 Congratulations! Your payment was successful</h3>
                    <p><span>Gateway</span>: <b>{responseData.gateway}</b></p>
                    <p><span>Invoice Number</span>: <b>{urlObject?.inv}</b></p>
                    <p><span>RRR</span>: <b>{urlObject?.rrr}</b></p>
                    {/* <p><span>Payment Reference</span>: <b>{responseData.reference}</b></p> */}
                    <p><span>Amount Paid</span>: <b>{this.formatCurrency(responseData.amount)}</b></p>
                    <p><span>Status</span>: <b style={{ color: 'green', textTransform: 'capitalize' }}>{responseData.status}</b></p>
                    
                    <div style={{ marginTop: '30px' }}>
                      <button
                        style={{
                          padding: '12px 24px',
                          background: '#1F1F1F',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          fontSize: '14px'
                        }}
                        onClick={this.navigateBack}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                )}

                {status === "failure" && !isVerifying && (
                  <div className={"confirm-payment__details-failed"}>
                    <h3 style={{marginTop: "20px"}}>❌ Payment Verification Failed</h3>
                    {urlObject?.inv && <p><span>Invoice Number</span>: <b>{urlObject.inv}</b></p>}
                    {urlObject?.rrr && <p><span>RRR</span>: <b>{urlObject.rrr}</b></p>}
                    {responseData?.gateway && <p><span>Gateway</span>: <b>{responseData.gateway}</b></p>}
                    {responseData?.amount && <p><span>Amount</span>: <b>{this.formatCurrency(responseData.amount)}</b></p>}
                    <p><span>Status</span>: <b style={{ color: 'red' }}>{responseData.status || "Payment was not successful"}</b></p>
                    
                    {/* <div style={{ marginTop: '20px' }}>
                      <button
                        style={{
                          padding: '12px 24px',
                          background: '#1F1F1F',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          marginRight: '10px'
                        }}
                        onClick={this.navigateBack}
                      >
                        Go Back
                      </button>
                      <button
                        style={{
                          padding: '12px 24px',
                          background: '#fff',
                          color: '#1F1F1F',
                          border: '1px solid #1F1F1F',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          fontSize: '14px'
                        }}
                        onClick={() => window.location.href = '/paymen'}
                      >
                        Try Again
                      </button>
                    </div> */}
                  </div>
                )}

                {!urlObject && !isVerifying && (
                  <div style={{ textAlign: 'center', padding: '40px' }}>
                    <h3>No payment details found</h3>
                    <p>The payment verification link is invalid or incomplete.</p>
                    <button
                      style={{
                        padding: '12px 24px',
                        background: '#1F1F1F',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        marginTop: '20px'
                      }}
                      onClick={() => window.location.href = '/invoice-payment'}
                    >
                      Go to Payment Page
                    </button>
                  </div>
                )}
              </div>
            </div>
          </ResponsiveContentLayout>
        </NoSidebarLayout>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

export default connect(mapStateToProps)(VerifyPayment);